// extracted by mini-css-extract-plugin
module.exports = {"tab":"styles__tab___3oZyv","separator":"styles__separator___2yL-e"};